import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { makeStyles, Menu, MenuItemRadio, MenuList, MenuPopover, MenuTrigger, SplitButton, Tooltip, } from "@fluentui/react-components";
import { ShellServiceIdentity } from "./shellService";
import { WeatherMoonRegular, WeatherSunnyRegular } from "@fluentui/react-icons";
import { useCallback } from "react";
import { useThemeMode } from "../hooks/themeHooks";
const useStyles = makeStyles({
    themeButton: {
        margin: 0,
    },
    themeMenuPopover: {
        minWidth: 0,
    },
});
export const ThemeSelectorServiceDefinition = {
    friendlyName: "ThemeSelector",
    consumes: [ShellServiceIdentity],
    factory: (shellService) => {
        const registration = shellService.addToolbarItem({
            key: "ThemeSelector",
            horizontalLocation: "right",
            verticalLocation: "top",
            teachingMoment: false,
            order: -300,
            component: () => {
                const classes = useStyles();
                const { isDarkMode, themeMode, setThemeMode } = useThemeMode();
                const onSelectedThemeChange = useCallback((e, data) => {
                    setThemeMode(data.checkedItems.includes("System") ? "system" : data.checkedItems[0].toLocaleLowerCase());
                }, []);
                const toggleTheme = useCallback(() => {
                    setThemeMode(isDarkMode ? "light" : "dark");
                }, [isDarkMode]);
                return (_jsxs(Menu, { positioning: "below-end", checkedValues: { theme: [themeMode] }, onCheckedValueChange: onSelectedThemeChange, children: [_jsx(MenuTrigger, { disableButtonEnhancement: true, children: (triggerProps) => (_jsx(Tooltip, { content: "Select Theme", relationship: "label", children: _jsx(SplitButton, { className: classes.themeButton, menuButton: triggerProps, primaryActionButton: { onClick: toggleTheme }, size: "small", appearance: "transparent", shape: "circular", icon: isDarkMode ? _jsx(WeatherSunnyRegular, {}) : _jsx(WeatherMoonRegular, {}) }) })) }), _jsx(MenuPopover, { className: classes.themeMenuPopover, children: _jsxs(MenuList, { children: [_jsx(MenuItemRadio, { name: "theme", value: "system", children: "System" }), _jsx(MenuItemRadio, { name: "theme", value: "light", children: "Light" }), _jsx(MenuItemRadio, { name: "theme", value: "dark", children: "Dark" })] }) })] }));
            },
        });
        return {
            dispose: () => registration.dispose(),
        };
    },
};
//# sourceMappingURL=themeSelectorService.js.map